import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'img[appImageFallback]',
})
export class ImageFallbackDirective {
  @Input() appImageFallback = 'images/placeholder.png';

  @HostListener('error', ['$event.target'])
  onError(img: HTMLImageElement) {
    img.src = this.appImageFallback || 'images/placeholder.png';
  }
}
